// Redux Actions
import * as ACTIONS from '../../../../../services/redux/actions'

export const UnfocusMap = (dispatch) => {

    dispatch(ACTIONS.v3_mapControl.set_map_control(0))
    dispatch(ACTIONS.v3_mapControl.disable_autofocus_2_highway_suv())

    return null
}